module.exports = __webpack_public_path__ + "img/124ne.010569cf.svg";